<div class="training-component">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <form class="example-form" *ngIf="isInviteVisible">
      <button mat-raised-button
              [routerLink]="['/invite']"
              style="border-radius: 6px; margin: 10px;">
        Bulk Registration
      </button>
    </form>

  </div>

  <div *ngIf="users && answers && trainings" style="width: 100%;">
    <p-table [value]="users"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             #table
             dataKey="department"
    >
      <ng-template pTemplate="header">
        <tr style="white-space: nowrap; font-weight: bold;">
          <th style="width: 20em;">User Name</th>
          <th *ngFor="let quiz of trainings" style="width: 20em;">{{quiz.quizData.name}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header"
            *ngIf="rowGroupMetadata && rowGroupMetadata[item.department].index === rowIndex">
          <td [attr.colspan]="trainings.length + 1">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{departments[item.department]}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-item>
        <tr>
          <td>{{getFullName(item.userId)}}</td>
            <td *ngFor="let quiz of trainings; let quizNumber = index">
              <div *ngFor="let a of answerData[item.userId][quizNumber]" [ngStyle]="{backgroundColor: a.status}" style="height: 20px;">
                {{a.date | date: 'shortDate'}}
              </div>
            </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
